//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'TechMeetup #3 Frontend',
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'TechMeetup #3 Frontend',
  description: [
  '28 марта (четверг) проведем очередной TechMeetup #3 Frontend от Холдинга Т1.',
  '<img style="margin-right:20px" width="40" height="40" src="assets/image-block/video.png"  align="left">Мероприятие пройдет в  гибридном формате (онлайн и офлайн), и будет посвящено одной из самых актуальных тем: фронтенд-разработке.',
  '<img style="margin-right:20px" width="40" height="40" src="assets/image-block/js.png"  align="left">Если ты пишешь на JS или просто интересуешься IT и языками программирования, то наш ивент точно для тебя!',
  '<img style="margin-right:20px" width="40" height="40" src="assets/image-block/gift.png"  align="left">А кроме интересных докладов, тебя ждет активное общение и нетворкинг с коллегами, а также приятные подарки от Т1.',
  '<img style="margin-right:20px" width="40" height="40" src="assets/image-block/bulb.png"  align="left">Завершим вечер ламповой афтепати, где можно будет расслабиться и отдохнуть в компании единомышленников.',
  '<img style="margin-right:20px" width="40" height="40" src="assets/image-block/chat2.png"  align="left">Давно мечтал выступить на митапе, но боялся сделать первый шаг? Не упусти эту возможность! Мы готовы помочь и поддержать тебя в подготовке к выступлению на будущих мероприятиях. <a href="https://survey.inno.tech/techmeetup_t1_cfp">Пройти онлайн-опрос: call for papers.</a>',
  '<img style="margin-right:20px" width="40" height="40" src="assets/image-block/agr.png"  align="left">Не забудь заглянуть на нашу страницу с <a href="http://bit.ly/t1career" target="_blank">вакансиями!</a> Возможно, именно у нас есть проекты твоей мечты!',
  '<br><b>Посмотри доклады:</B>',
  '<ul><li>Дмитрий Трифонов: <a href="https://sigma.disk.t1.cloud/public/wb02rA_I">Назад в будущее или как я календарь делал</a></li><li>Герман Никитин: <a href="https://sigma.disk.t1.cloud/public/Nvf74A_I">Разработка чат бота с использованием React и библиотеки Urban Bot</a></li><li>Никита Любицкий: <a href="https://sigma.disk.t1.cloud/public/d2sP9A_I">Приложения без бэкенда</a></li><li>Павел Василюк: <a href="https://sigma.disk.t1.cloud/public/XhOvtA_I">Резюме и тех собеседования</a></li></ul>'
  ],
  date: '28.03.2024',
  time: '19:00-22:00'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'ESojfGdK',
          id: 2228,
          hallName: 'Первый зал' // название зала
        //   },
        //   {
        //     hash: 'PXBhAboi',
        //     id: 1106,
        //     hallName: 'Второй зал'
        }
      ]
    }
    // {
    //   tabName: '16.06.3023',
    //   items: [
    //     {
    //       hash: 'MAclQpGI',
    //       id: 1357,
    //       hallName: 'Третий зал'
    //     }
    //   ]
    // }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться:', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/Map.png'), // путь до изображения для блока с картинкой
    items: [
      'м. Красносельская/Бауманская, Спартаковский переулок 2с1, подъезд №7 (арт-пространство "Весна", 2 этаж).',
      '<a href="https://yandex.ru/maps/-/CDutqPJk" target="_blank">Яндекс.Карты</a>'
    ]
  },
  info: {
    title: 'О площадке', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      'Данный блок достаточно гибкий, в него можно поместить текст, картинки и ссылки по аналогии с первый блоком на данной странице. Часто сюда попадает та информация, о которой хотят сказать организаторы, но которую не считают настолько нужной, чтобы помещать ее перед плеером.'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
